export default {
  hero: {
    cyclingWords: [
      'comportamento',
      'linguagem',
      'acessibilidade',
      'inclusão',
      'percepção',
      'atenção',
      'memória',
      'curiosidade',
      'aprendizado',
      'conexão',
      'adaptação',
      'clareza',
      'compreensão',
      'pertencimento',
      'confiança',
      'maravilha',
      'possibilidades',
      'sentimento',
    ],
    label: 'Product Design Engineer',
    status: 'Disponível para as coisas certas',
    headline: {
      line1: 'construo',
      em: 'coisas',
      line3: 'para humanos.',
    },
    desc: 'Olá, sou <strong>Juan Lias</strong>, um maker multidisciplinar localizado em Curitiba, Brasil. Combino empatia de design com precisão de engenharia para criar experiências digitais que parecem humanas desde o primeiro clique.',
    description: 'Olá, sou um maker multidisciplinar <br /> localizado em Curitiba, PR-Brasil',
    title: {
      first: 'Criando',
      highlight: 'digital',
      last: 'experiências.',
    },
    scroll: 'Scroll',
    photoAlt: 'Juan Lias — Product Design Engineer',
    ariaSection: 'Hero — Juan Lias portfolio',
  },
  about: {
    watermark: 'Quem sou',
    title: 'Quem sou',
    seeMore: {
      label: 'Descobrir mais',
      title: 'Conheça-me',
    },
    story:
      "Cresci no Caribe, em uma <span class='story-highlight'>Venezuela</span> que moldava com dureza, dias bons, dias difíceis e uma criatividade nascida da urgência. Lá aprendi a resolver com pouco e a ver ordem onde outros viam caos. Em 2019 migrei para o <span class='story-highlight'>Brasil</span> em busca de estabilidade e um futuro mais claro. Esse salto me obrigou a começar do zero, me reinventar e provar que eu poderia subir de nível mesmo em terreno novo.",
    heroCard: {
      role: 'Desenvolvedor Criativo e Designer de Interfaces',
      bio: 'Apaixonado por criar experiências digitais que realmente se conectem com as pessoas. Combino a lógica do código com a empatia do design para construir soluções úteis, focando na eliminação de atritos para alcançar interfaces que pareçam familiares e naturais desde o primeiro instante.',
      showMore: 'Ver mais',
      showLess: 'Ver menos',
    },
    locationCard: {
      label: 'Localizado em',
      country: 'Brasil',
    },
    availabilityCard: {
      status: 'Disponível',
      message: 'para a coisa certa',
    },
    quoteCard: {
      philosophy: '— Minha filosofia',
      segments: [
        { text: 'Não busco a perfei', type: 'type' },
        { text: 'cao', type: 'type', isTypo: true },
        { text: '', type: 'pause', duration: 600 },
        { text: 'cao', type: 'delete' },
        { text: 'ção,', type: 'type' },
        { text: '', type: 'pause', duration: 800 },
        { text: ' só tento ser extraordinário.', type: 'type' },
      ],
    },
    experienceCard: {
      label: 'Anos de<br />Experiência',
    },
    neurodivergentCard: {
      teaser: "Minha mente funciona <span class='teaser__highlight'>diferente</span>.",
      teaserSub: 'Autismo N1 · Altas Habilidades',
      button: 'Ver perfil cognitivo',
      label: 'Neurodivergente',
      sublabel: 'Perfil Cognitivo',
      hide: 'Fechar',
      traits: [
        { id: 'hyperfocus', name: 'Hiperfoco' },
        { id: 'patterns', name: 'Rec. de Padrões' },
        { id: 'precision', name: 'Precisão' },
        { id: 'systems', name: 'Pensamento Sistêmico' },
        { id: 'lateral', name: 'Pensamento Lateral' },
        { id: 'curiosity', name: 'Curiosidade Profunda' },
      ],
      footer:
        "Diferente por design. <span class='footer-highlight'>Resultados extraordinários.</span>",
    },
    hobbiesCard: {
      title: 'Além do sistema',
      text: 'Fé, ciência e o impulso de superação. Um equilíbrio entre o design de Deus, as leis da física e a disciplina de quebrar meus próprios limites.',
      hobbies: [
        'Deus',
        'Família',
        'Ciência',
        'Física',
        'Astrofísica',
        'Design',
        'Artes',
        'Música',
        'Gaming',
        'Dragon Ball',
      ],
    },
    readingCard: {
      title: 'Lendo atualmente',
    },
    familyCard: {
      title: "Família em primeiro lugar <span class='family-card__hearts'>❤️</span>",
      text: 'Minha família é minha força quando fraquejo, minha alegria quando estou exausta e a razão pela qual nunca paro. São minha prioridade, meu chão firme e minha bênção diária. Agradeço a Deus por nos guiar e sustentar em cada passo.',
    },
    momentsCard: {
      title: 'Momentos por trás dos pixels',
      labels: {
        alwaysLearning: 'Sempre aprendendo 📚',
        dreamTeam: 'Dream Team 💜',
      },
    },
    setupCard: {
      items: {
        dell: { detail: 'Core i7 13th Gen • GEFORCE RTX • 32GB RAM • 1TB SSD' },
        mic: { detail: 'Microfone Condensador USB' },
        webcam: { detail: 'Webcam 2k' },
        mouse: { detail: 'Mouse' },
        mousepad: { detail: 'Mousepad' },
        tablet: { detail: 'Tablet Gráfico' },
        buds1: { detail: 'Fones Sem Fio' },
        buds2: { detail: 'Fones Sem Fio' },
        headphones: { detail: 'Headphones Over-Ear' },
        keyboard: { detail: 'Teclado' },
        bible: { detail: 'Guia Espiritual' },
        book: { detail: 'Livro UX de Don Norman' },
        speaker: { detail: 'Smart Speaker' },
        monitor1: { detail: 'Full HD • IPS' },
        timer: { detail: 'Temporizador Pomodoro' },
        monitor2: { detail: 'Full HD • IPS' },
        controller: { detail: 'Para pausas de jogo 🎮' },
      },
    },
    languagesCard: {
      title: 'Idiomas',
      items: [
        { name: 'Espanhol', level: 'Nativo' },
        { name: 'Português', level: 'Fluente' },
        { name: 'Inglês', level: 'Proficiência profissional de trabalho' },
      ],
    },
  },
  whatIDo: {
    title: {
      first: 'O que',
      highlight: 'Eu Faço',
    },
    services: {
      uiUx: {
        title: 'UI/UX',
        description:
          'Criando interfaces intuitivas centradas no usuário que combinam estética com funcionalidade perfeita',
      },
      frontend: {
        title: 'ENGINEER',
        description:
          'Engenharia de aplicações web escaláveis e de alto desempenho usando arquitetura moderna',
      },
      creative: {
        title: 'CRIATIVO',
        description: 'Projetando e programando interfaces digitais com um toque humano.',
      },
      interaction: {
        title: 'INTERACTION',
        description: 'Cada clique, hover e scroll — obsessivamente considerado.',
      },
      humanity: {
        title: 'HUMANITY',
        description: 'Propósito humano, execução técnica.',
      },
    },
  },
  worksComingSoon: {
    badge: 'Em Construção',
    title: 'Analisando Ideias<br />Para a Realidade',
    description:
      'Atualmente estou selecionando meus melhores projetos para mostrar aqui. Espere algo especial em breve.',
    loading: {
      initializing: 'Inicializando...',
      states: [
        'Melhorando Casos de Uso...',
        'Projetando Fluxos de Usuário...',
        'Otimizando Ativos Gráficos...',
        'Refinando Interações...',
        'Preparando Documentação...',
        'Compilando Melhores Projetos...',
      ],
    },
  },
  journeyV2: {
    label: 'Cronograma de Carreira',
    title: 'Experiência',
    connect: 'Conectar no LinkedIn',
    items: [
      {
        id: 1,
        company: 'Compliance Soluções',
        role: 'Consultor Sênior/Especialista em Desenvolvimento UX',
        location: 'Remoto - Ribeirão Preto, São Paulo, Brasil',
        period: 'Mai 2022 - Atual',
        description:
          'Liderando a migração UX de uma plataforma fiscal legada atendendo a mais de 100 empresas. Otimizando fluxos de trabalho para mais de 20k faturas mensais através de pesquisa, prototipagem e colaboração próxima com Product Owners.',
        startYear: 2022,
        endYear: 2025,
      },
      {
        id: 2,
        company: 'Simplify Tanzania',
        role: 'Diretor de Arte',
        location: 'Remoto - Dar es Salaam, Tanzânia',
        period: 'Jun 2019 - Dez 2022',
        description:
          'Liderei a direção criativa desde a definição do MVP até a implementação frontend. Projetei interfaces de alta fidelidade para gestão de faturas e estabeleci a identidade visual da marca em canais digitais e sociais.',
        startYear: 2019,
        endYear: 2022,
        roles: [
          {
            title: 'Diretor de Arte',
            period: 'Fev 2021 - Out 2022',
            type: 'Tempo Integral',
          },
          {
            title: 'Designer de Produto UI/UX Sênior e Desenvolvedor Front-end',
            period: 'Out 2020 - Fev 2021',
            type: 'Contrato',
          },
        ],
      },
      {
        id: 3,
        company: 'Katavi Gaming Limited',
        role: 'Consultor Sênior de Design de Produto UI/UX',
        location: 'Dar es Salaam, Tanzânia',
        period: 'Out 2017 - Mai 2022',
        description:
          'Chefiei o departamento de UI/UX para plataformas de apostas, otimizando para acessibilidade de dispositivos. Gerenciei o ciclo completo de design desde a pesquisa até o lançamento usando SCRUM, enquanto definia a identidade corporativa e ativos de marketing.',
        startYear: 2017,
        endYear: 2022,
        roles: [
          {
            title: 'Consultor Sênior de Design de Produto UI/UX',
            period: 'Dez 2020 - Mai 2022',
            type: 'Freelance',
          },
          {
            title: 'Designer de Produto UI/UX e Desenvolvedor Front-end',
            period: 'Abr 2018 - Dez 2020',
            type: 'Tempo Integral',
          },
          {
            title: 'Desenvolvedor Front-end Júnior e Designer UI/UX',
            period: 'Out 2017 - Abr 2018',
            type: 'Tempo Integral',
          },
        ],
      },
      {
        id: 4,
        company: 'Freelancer',
        role: 'Designer de Produto e Desenvolvedor',
        location: 'Global',
        period: 'Jan 2016 -',
        description:
          'Fornecendo soluções versáteis de design e desenvolvimento para clientes globais. Os projetos variam desde a criação de identidades corporativas e embalagens para marcas educacionais até o design de interfaces para plataformas de jogos emergentes.',
        startYear: 2016,
        endYear: 2025,
      },
    ],
  },
  testimonials: {
    title: 'Impacto Colaborativo',
    subtitle: 'Tive o prazer de colaborar com pessoas incríveis. Aqui está o que elas têm a dizer.',
    items: [
      {
        id: 1,
        initials: 'J. A.',
        name: 'Jesus A. A. Rojas',
        role: 'Chefe de Armazém na Traslogistic de Venezuela',
        company: 'TBET',
        quote:
          'Juan tem um poder criativo incrível, aprende rápido e é autodidata. Ele tem a habilidade de captar a visão do projeto e usar suas habilidades para melhorá-lo ou agregar valor.',
        linkedin: 'https://www.linkedin.com/in/jesus-armando-acosta-rojas/',
      },
      {
        id: 2,
        initials: 'B. C.',
        name: 'Baraka S. Cassian',
        role: 'Fundador e Diretor Geral, Simplitech Ltd (Simplify)',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Trabalhar com Juan no produto e na experiência frontend da Simplify foi um prazer. Ele entendeu rapidamente nosso produto, nossos usuários e as restrições em que operamos, e então traduziu ideias soltas em interfaces limpas e intuitivas. Apreciei como ele se comunicava claramente, iterava rápido no feedback e prestava atenção aos pequenos detalhes que fazem um produto parecer polido. Juan traz uma mistura rara de habilidade de design, confiabilidade e cuidado genuíno pelo resultado do projeto. Ele é, no geral, uma pessoa amigável e ótima para trabalhar!',
        linkedin: 'https://www.linkedin.com/in/bcassian/',
      },
      {
        id: 3,
        initials: 'C. Z.',
        name: 'Carlos Zerpa',
        role: 'Senior Software Enginner',
        company: 'SIMPLIFY',
        quote:
          'Trabalhar ao lado de Juan Lias no projeto Simplify VFD foi um testemunho de seu talento excepcional. Sua liderança em design de produto, aliada à sua experiência em Vue.js, resultou em uma aplicação polida e intuitiva. Seu profissionalismo, atenção aos detalhes e espírito colaborativo o tornam um designer e desenvolvedor de destaque.',
        linkedin: 'https://www.linkedin.com/in/carlos-javier-zerpa/',
      },
      {
        id: 4,
        initials: 'M. V.',
        name: 'Mariana Vielma',
        role: 'Product Owner',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Juan é um profissional extraordinário com um talento incrível e um ótimo senso de humor, tornando a colaboração produtiva e agradável. Seus designs sempre carregam sua assinatura "centelha extra", aquele toque único que eleva cada projeto e deixa você querendo ver mais de seu trabalho. Ele consistentemente dá 100% em tudo o que faz, trazendo criatividade, atenção aos detalhes e visão forte que agregam valor real a qualquer produto ou equipe.',
        linkedin: 'https://www.linkedin.com/in/mariana-vielma-67585a237/',
      },
      {
        id: 5,
        initials: 'C. S.',
        name: 'Cezar Sakugawa',
        role: 'Product Manager',
        company: 'Compliance Soluções Fiscais',
        quote:
          'Tive o privilégio de liderar o Juan e posso dizer que ele se destaca onde poucos conseguem equilibrar: visão estratégica de produto com execução refinada no design. Sua atenção aos detalhes vai além da estética — ele pensa na experiência do usuário de ponta a ponta. A comunicação clara e a postura colaborativa fazem dele alguém que eleva o nível de qualquer time que tem a sorte de tê-lo.',
        linkedin: 'https://www.linkedin.com/in/cezarsakugawa/',
      },
      {
        id: 6,
        initials: 'V. S.',
        name: 'Vinícius Santos',
        role: 'Product Owner',
        company: 'Compliance Soluções Fiscais',
        quote:
          'Na empresa onde trabalhei com Juan, mantivemos contato a todo momento desde o início ao fim, fazendo com que a colaboração fosse sempre ativa e efetiva. Admito que, por ser Product Owner, é complexo dar atenção à todas as partes interessadas, mas o Juan nunca se escondeu e sempre mostrou iniciativa ao me procurar, seja para tirar uma dúvida ou até para me apresentar um protótipo de alta fidelidade de um incremento novo. Nunca teve medo de mostrar suas ideias e trabalhar duro nelas para torná-las realidade, sempre procurando ouvir feedbacks para melhorar cada vez mais e entregar valor ao usuário. A vontade de fazer acontecer é, sem dúvidas, o seu ponto mais forte.',
        linkedin: 'https://www.linkedin.com/in/vinícius-santos',
      },
    ],
  },
  works: {
    section: {
      built: 'O que eu construí',
      building: 'O que estou construindo',
      otherLine1: '& outras coisas',
      otherLine2: 'que construí e ajudei a construir',
      closing: 'Ainda aprendendo. Ainda construindo.',
    },
    ui: {
      caseStudy: 'Estudo de Caso',
      comingSoon: 'Em breve',
      visitProject: 'Visitar Projeto',
    },
    projects: {
      'ultra-instinct': {
        category: 'Extensão do VS Code',
        description:
          'Uma trilogia de temas para VS Code projetada para neurodivergentes, criada para eliminar o ruído visual e atingir um estado de foco profundo e fluxo.',
      },
      braillihub: {
        category: 'Ferramenta de Acessibilidade',
        description:
          'Um espaço para explorar as línguas que conectam as pessoas, além das palavras. Traduza texto para Braille, Código Morse ou Cifra de César — e explore cada um com ferramentas interativas projetadas para a curiosidade.',
      },
      milo: {
        category: 'Personagem de Marca',
        description:
          'Milo é o personagem de marca do Braillihub — um pequeno explorador curioso que acredita que toda língua merece ser compreendida. Ele está aqui para incorporar o espírito da descoberta e te acompanhar enquanto você explora Braille, Morse e muito mais.',
      },
      firmamesh: {
        category: 'Gradientes Atmosféricos',
        description:
          'Explore 141 paisagens atmosféricas reais de 75 países, com 5 momentos do dia usando OKLCH para transições de cores vivas. O slider percorre o arco solar completo — do nadir ao zênite — com sol, lua e estrelas em tempo real e fase lunar astronômica. Copie gradientes como CSS, exporte SVG para Figma ou baixe imagens em alta resolução. Inclui editor de camadas atmosféricas com controle fino de luminosidade, croma e matiz.',
      },
      hyperdrive: {
        category: 'Portfólio Web',
        description:
          'Um impressionante site de portfólio com uma animação de viagem pelo hiperespaço construído com Vue 3 e com suaves transições GSAP.',
      },
    },
    inProgress: {
      hogarflow: {
        category: 'Centro de Comando do Lar',
        description:
          'HogarFlow é uma plataforma inteligente para o lar que centraliza finanças, compras, tarefas e rotinas em um só lugar — projetada para que os usuários parem de gerenciar e comecem a viver, com Shury como a assistente de IA que cuida de tudo.',
      },
      shury: {
        category: 'Assistente IA do HogarFlow',
        description:
          'Shury é a assistente de IA do HogarFlow — ela gerencia finanças, tarefas, notas, assinaturas e cuida dos afazeres do lar em nome do usuário, para que possam viver com calma e controle.',
      },
    },
    otherProjects: {
      tbet: {
        description:
          'Liderou o departamento de UI/UX na Katavi Gaming Limited (Tanzânia) — pesquisa de usuários, sistema de design, wireframes e UI focada em acessibilidade para dispositivos mais antigos. Também foi responsável pela implementação do frontend. Seguiu o ciclo completo de desenvolvimento do produto sob SCRUM/Jira, e colaborou com o marketing na identidade corporativa e visuais para redes sociais.',
      },
      cassian: {
        description:
          'Rebranding completo e renovação do site de uma firma de contabilidade pública certificada e consultoria fiscal na Tanzânia (Dar es Salaam e Arusha) — renovação da identidade visual, redesign completo do site, do conceito à implantação.',
      },
      'simplify-vfd': {
        description:
          'Na Simplitech Limited (Tanzânia), liderou o design do produto de ponta a ponta — pesquisa de concorrentes, identidade de marca, definição do MVP e interfaces de alta fidelidade. Também foi responsável por todo o frontend e integrações com APIs, e co-projetou o sistema visual de marketing.',
      },
    },
  },
}
